// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"820":"8b39d8cadb96ccc3","928":"033aaa8f3028893a"}[chunkId] + ".js";
};